import { render, staticRenderFns } from "./CustomerList.vue?vue&type=template&id=6823f172&scoped=true"
import script from "./CustomerList.vue?vue&type=script&lang=js"
export * from "./CustomerList.vue?vue&type=script&lang=js"
import style0 from "./CustomerList.vue?vue&type=style&index=0&id=6823f172&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6823f172",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JSH_ERP\\JSH_ERP\\mgerpweb\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6823f172')) {
      api.createRecord('6823f172', component.options)
    } else {
      api.reload('6823f172', component.options)
    }
    module.hot.accept("./CustomerList.vue?vue&type=template&id=6823f172&scoped=true", function () {
      api.rerender('6823f172', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/CustomerList.vue"
export default component.exports